import * as React from 'react';

export interface BottomSlotProps {
  children?: React.ReactNode;
}

const BottomSlot = ({ children }: BottomSlotProps) => {
  if (!children) {
    return null;
  }
  return (
    <div className="tw:flex tw:flex-col tw:gap-s tw:w-full">{children}</div>
  );
};

export { BottomSlot };
